export default "__VITE_ASSET__CxiJVUZr__"